"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="our-story" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">

          {/* TEXT COLUMN */}
          <div ref={textRef} className="space-y-6 lg:pr-8 relative after:hidden lg:after:block after:absolute after:top-0 after:right-0 after:w-px after:h-full after:bg-border">
            <div className={`transition-all duration-500 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "0ms"
          }}>
              <h2 className="text-foreground font-display">Our Story</h2>
            </div>

            <div className={`transition-all duration-500 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "200ms"
          }}>
              <p className="text-muted-foreground leading-relaxed">
                Sloane &amp; Co. LLP is a firm of Chartered Certified
                Accountants with a long-standing reputation for delivering
                trusted, high-quality accounting services. The firm was founded
                in 1974 by David Sloane, whose vision and values shaped Sloane
                &amp; Co. for over four decades.
                <br /><br />
                In 2015, David retired, marking the beginning of a new chapter
                in the firm’s history. Leadership passed to Mark Allen and Rishi
                Lokye, who have continued to build on the firm’s strong
                foundations while driving it forward with a modern, proactive
                approach. Mark has been part of the Sloane &amp; Co. family for
                over 25 years, with Rishi contributing more than 10 years of
                experience, ensuring continuity, stability, and deep
                understanding of our clients’ needs.
                <br /><br />
                We pride ourselves on our excellent reputation for delivering a
                professional yet personal service to all our clients, regardless
                of size or complexity. Our approach is built on strong
                relationships, clear communication, and tailored advice that
                supports informed decision-making.
                <br /><br />
                At Sloane &amp; Co., we combine decades of experience with a
                forward-thinking mindset. More than accountants, we are trusted
                advisers, committed to supporting our clients’ long-term success
                and financial confidence.
              </p>
            </div>
          </div>

          {/* STATIC IMAGE COLUMN */}
          <div className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden rounded-lg shadow-medium bg-cover bg-center !bg-[url(https://sloane.uk/wp-content/uploads/2026/02/MBF-front.jpeg)]" />
        </div>
      </div>
    </section>;
}